(function () {
    var directivesModule = angular.module('customeDirectivesModule');

    directivesModule.directive('npPrintButton', ['$document', '$timeout', 'broadcastService', function ($document, $timeout, broadcastService) {
        return {
            restrict: 'E',
            controller: ['$scope', '$stateParams', '$http', 'localStorageService', 'pubSub', 'browserService', 'configService', controller],
            controllerAs: 'vm',
            scope: {
                typePrintContextMenu: '=',
                id: '=',
                fieldId: '=',
                custom: '=',
                searchType: '=',
                toggleSidebar: '=',
				isBooklet: '=',
                periodOption: '=',
                knowledgeTypeId: '='
            },
            templateUrl: paths.PrintButtonView,
            replace: true,
            link: function (scope, element, attr) {
                scope.$watch('toggleSidebar', function () {
                    $timeout(function () {
                        getColumnsDefinition();
                        broadcastService(broadcastType.gridSettingTarget, commonColumnsDefinition);
                    }, 0, false);
                });

                scope.$watch('custom', function (custom) {
                    if (scope.custom == true) {
                        angular.element('#print-box2').removeClass(avoidCustomPageClass);
                    } else {
                        angular.element('#print-box2').addClass(avoidCustomPageClass);
                    }
                });

                scope.showPrintContextMenu = false;
                scope.showPrintFolderMenu = false;
                $document.bind('click', function (event) {
                    var isClickedElementChildOfPopup = element
                        .find(event.target)
                        .length > 0;

                    if (isClickedElementChildOfPopup)
                        return;
                    scope.showPrintFolderMenu = false;
                    scope.showPrintContextMenu = false;
                    scope.$apply();
                });
            }
        };
    }]);

    function controller($scope, $stateParams, $http, localStorageService, pubSub, browserService, configService) {
        var vm = this;
        vm.fieldName = '';
        vm.calculateWidthOfPrintBox = calculateWidthOfPrintBox;
        $scope.translation = globalResources;
        vm.onRecursiveChange = onRecursiveChange;
        if ($scope.translation.Print.indexOf('\n(CTRL + ALT + P)') <= 0) {
            $scope.translation.Print = $scope.translation.Print + '\n(CTRL + ALT + P)';
        }
        $scope.enableSimplePrintout = configService.getBool(HandbookConfiguration.EnableSimplePrintout);
        $scope.folderSettingsEnabled = configService.getBool(HandbookConfiguration.FolderSettingsEnabled);

        $scope.isTitle = $scope.folderSettingsEnabled ? true : false;
        $scope.isDocumentId = $scope.folderSettingsEnabled ? true : false;
        $scope.isVersion = $scope.folderSettingsEnabled ? true : false;
        $scope.isDocumentResponsible = false;
        $scope.isApprover = false;
        $scope.knowledgeType = KnowledgeType;
        $scope.enableAgree = configService.getBool(HandbookConfiguration.EnabledAgree);
        $scope.publishedVersion = configService.getBool(HandbookConfiguration.PublishedVersion);
        vm.BROWSER_TYPE = BrowserType;
        vm.browserType = browserService.detectBrowserWindow();

        var finishLoadContent = null;
        initialize();

        function initialize() {
            finishLoadContent = pubSub.subscribe(broadcastType.loadContentFieldDone, fieldContentChanges);
            var printRecursive = localStorageService.getItem('PrintFoldersRecursive');
            $scope.recursive = printRecursive == null ? true : (printRecursive == 'true' || printRecursive == 'True');
        };

        function closeContextMenuPrint() {
            $scope.showPrintContextMenu = false;
        }

        function closeContextMenuPrintFolder() {
            $scope.showPrintFolderMenu = false;
        }

        $scope.$on('$destroy', function () {
            finishLoadContent();
        });

        function calculateWidthOfPrintBox() {
            var maxWidth = $('.topmenu-right-panel').width();
            return { 'max-width': maxWidth, 'width': 'unset' };
        }
        function fieldContentChanges(params) {
            //remove the order of field name
            if (params.fieldName) {
                var fieldName = angular.copy(params.fieldName).toString();
                vm.fieldName = fieldName;
                var indexOfFieldOrder = fieldName.indexOf('.');
                if (indexOfFieldOrder > 0)
                {
                    vm.fieldName = fieldName.substr(indexOfFieldOrder + 2, fieldName.length);
                }
            }
        }
        function onRecursiveChange($event) {
            localStorageService.setItem('PrintFoldersRecursive', $scope.recursive);
        }

        //print entire document to pdf file
        $scope.printDocumentPdf = function () {
            window.open(String.format(handbookRequests.PrintPdfRequest, $scope.id));
            closeContextMenuPrint();
        };

        $scope.printDocumentBooklet = function () {
            window.open(String.format(handbookRequests.PrintBrochureRequest, $scope.id));
            closeContextMenuPrint();
        }

        //print document field to pdf file
        $scope.printDocumentFieldPdf = function () {
            window.open(String.format(handbookRequests.PrintPdfFieldRequest, $scope.id, $scope.fieldId));
            closeContextMenuPrint();
        }
        //print entire document to html page
        $scope.printDocument = function () {
            window.open(String.format(handbookRequests.PrintHtmlRequest, $scope.id));
            closeContextMenuPrint();
        };
        //print document field to html page
        $scope.printDocumentFieldHtml = function () {
            window.open(String.format(handbookRequests.PrintHtmlFieldRequest, $scope.id, $scope.fieldId));
            closeContextMenuPrint();
        }

        $scope.printSimplifiedDocumentPdf = function () {
            window.open(String.format(handbookRequests.PrintPdfSimpleRequest, $scope.id));
            closeContextMenuPrint();
        }

        $scope.printFolderHtml = function (printType) {
            var groupBy = E.exportDocumentGroupsByColumn.none;
            if ($scope.$parent.vm.folderInformation.viewType == documentViewTypes.DocumentViewTypes_Standard) {
                groupBy = E.exportDocumentGroupsByColumn.none;
            } else if ($scope.$parent.vm.folderInformation.viewType == documentViewTypes.DocumentViewTypes_Template) {
                groupBy = E.exportDocumentGroupsByColumn.documentType;
            } else {
                groupBy = E.exportDocumentGroupsByColumn.metatag;
            }
            if (HandbookConfiguration.PrintFolderAsBackground == "True") {
                $http.post(handbookRequests.AddPrintFolderJobRequest, {
                    'folderId': $scope.id,
                    'exportType': 1,
                    'displayType': printType,
                    'recursive': $scope.recursive == true ? 1 : 0,
                    'isDocTitle': $scope.isTitle == true ? 1 : 0,
                    'isDocId': $scope.isDocumentId == true ? 1 : 0,
                    'isVersion': $scope.isVersion == true ? 1 : 0,
                    'isDocResponsible': $scope.isDocumentResponsible == true ? 1 : 0,
                    'isApprover': $scope.isApprover == true ? 1 : 0,
                    'groupBy': groupBy,
                }).then(function (response, status, headers, config) {
                    alert($scope.translation.ConfirmPrintChapterHTMLAsBackgroundJob);
                });
            } else {
                if (!$scope.folderSettingsEnabled) {
                    var params = {
                        includeSubFolders: $scope.recursive,
                        type: printType,
                        folderIdInt: $scope.id,
                        groupBy: groupBy,
                        metadataGroupId: $scope.$parent.vm.folderInformation.viewType,
                        includeLevel1: $scope.$parent.vm.showDocumentIncludeLevel1
                    };

                    window.open(handbookRequests.PrintFolderHtmlConfigRequest + $.param(params));
                } else {
                    var params = {
                        printType: printType,
                        isApprover: $scope.isApprover,
                        isDocResponsible: $scope.isDocumentResponsible,
                        isVersion: $scope.isVersion,
                        isDocId: $scope.isDocumentId,
                        isDocTitle: $scope.isTitle,
                        includeSubFolders: $scope.recursive,
                        type: printType,
                        folderIdInt: $scope.id,
                        groupBy: groupBy,
                        metadataGroupId: $scope.$parent.vm.folderInformation.viewType,
                        includeLevel1: $scope.$parent.vm.showDocumentIncludeLevel1
                    };

                    window.open(handbookRequests.PrintFolderHtmlConfigRequest + $.param(params));
                }
            }
            closeContextMenuPrintFolder();
        };

        $scope.printFolderPdf = function (printType) {
            var groupBy = E.exportDocumentGroupsByColumn.none;
            if ($scope.$parent.vm.folderInformation.viewType == documentViewTypes.DocumentViewTypes_Standard) {
                groupBy = E.exportDocumentGroupsByColumn.none;
            } else if ($scope.$parent.vm.folderInformation.viewType == documentViewTypes.DocumentViewTypes_Template) {
                groupBy = E.exportDocumentGroupsByColumn.documentType;
            } else {
                groupBy = E.exportDocumentGroupsByColumn.metatag;
            }
            if (HandbookConfiguration.PrintFolderAsBackground == "True") {
                $http.post(handbookRequests.AddPrintFolderJobRequest, {
                    'folderId': $scope.id,
                    'exportType': 2,
                    'displayType': printType,
                    'recursive': $scope.recursive == true ? 1 : 0,
                    'isDocTitle': $scope.isTitle == true ? 1 : 0,
                    'isDocId': $scope.isDocumentId == true ? 1 : 0,
                    'isVersion': $scope.isVersion == true ? 1 : 0,
                    'isDocResponsible': $scope.isDocumentResponsible == true ? 1 : 0,
                    'isApprover': $scope.isApprover == true ? 1 : 0,
                    'groupBy': groupBy,
                }).then(function (response, status, headers, config) {
                    alert($scope.translation.ConfirmPrintChapterPDFAsBackgroundJob);
                });
            } else {
                if (!$scope.folderSettingsEnabled) {
                    var params = {
                        includeSubFolders: $scope.recursive,
                        type: printType,
                        folderIdInt: $scope.id,
                        groupBy: groupBy,
                        metadataGroupId: $scope.$parent.vm.folderInformation.viewType,
                        includeLevel1: $scope.$parent.vm.showDocumentIncludeLevel1
                    };

                    window.open(handbookRequests.PrintFolderPdfConfigRequest + $.param(params));
                } else {
                    var params = {
                        printType: printType,
                        isApprover: $scope.isApprover,
                        isDocResponsible: $scope.isDocumentResponsible,
                        isVersion: $scope.isVersion,
                        isDocId: $scope.isDocumentId,
                        isDocTitle: $scope.isTitle,
                        includeSubFolders: $scope.recursive,
                        type: printType,
                        folderIdInt: $scope.id,
                        groupBy: groupBy,
                        metadataGroupId: $scope.$parent.vm.folderInformation.viewType,
                        includeLevel1: $scope.$parent.vm.showDocumentIncludeLevel1
                    };

                    window.open(handbookRequests.PrintFolderPdfConfigRequest + $.param(params));
                }
            }
            closeContextMenuPrintFolder();
        };

        $scope.printWhatsNewHtml = function (printType) {
            if ($scope.id == null) {
				window.open(String.format(handbookRequests.PrintWhatsNewHtmlRequest, printType, $scope.getColumnSettings(), $scope.periodOption));
            } else {
				window.open(String.format(handbookRequests.PrintFolderWhatsNewHtml, printType, $scope.getColumnSettings(), $scope.id, $scope.searchType, $scope.periodOption));
            }
            closeContextMenuPrint();
        };

        $scope.printWhatsNewPdf = function (printType) {
            if ($scope.id == null) {
				window.open(String.format(handbookRequests.PrintWhatsNewPdfRequest, printType, $scope.getColumnSettings(), $scope.periodOption));
            } else {
				window.open(String.format(handbookRequests.PrintFolderWhatsNewPdf, printType, $scope.getColumnSettings(), $scope.id, $scope.searchType, $scope.periodOption));
            }
            closeContextMenuPrint();
        };

        $scope.printUpdatedFavoriteHtml = function (printType) {
            window.open(String.format(handbookRequests.PrintUpdatedFavoriteHtmlRequest, printType, $scope.getColumnSettings()));
            closeContextMenuPrint();
        };

        $scope.printUpdatedFavoritePdf = function (printType) {
            window.open(String.format(handbookRequests.PrintUpdatedFavoritePdfRequest, printType, $scope.getColumnSettings()));
            closeContextMenuPrint();
        };

        $scope.printSearchResultHtml = function (printType) {

            var params = {
                printType: printType,
                columns: $scope.getColumnSettings(),
                keyword: $stateParams.keyword,
                documentTypeId: $stateParams.template,
                searchInContents: $stateParams.searchInContents == true,
                fromDate: $stateParams.fromDate != null ? FormattedDateDMYYYY(new Date(parseInt($stateParams.fromDate)), '/') : null,
                toDate: $stateParams.toDate != null ? FormattedDateDMYYYY(new Date(parseInt($stateParams.toDate)), '/') : null,
                searchType: $scope.searchType,
                folderId: $stateParams.folderId
            };

            window.open(handbookRequests.PrintSearchResultHtmlRequest + $.param(params));
            closeContextMenuPrint();
        };

        $scope.printSearchResultPdf = function (printType) {

            var params = {
                printType: printType,
                columns: $scope.getColumnSettings(),
                keyword: $stateParams.keyword,
                documentTypeId: $stateParams.template,
                searchInContents: $stateParams.searchInContents == true,
                fromDate: $stateParams.fromDate != null ? FormattedDateDMYYYY(new Date(parseInt($stateParams.fromDate)), '/') : null,
                toDate: $stateParams.toDate != null ? FormattedDateDMYYYY(new Date(parseInt($stateParams.toDate)), '/') : null,
                searchType: $scope.searchType,
                folderId: $stateParams.folderId
            };

            window.open(handbookRequests.PrintSearchResultPdfRequest + $.param(params));
            closeContextMenuPrint();
        };

        $scope.getColumnSettings = function () {
            var columnSettings = '';
            var spliter = handbookConstants.ColumnsSplitter;
            if (commonGridSetting.internet.visible) {
                columnSettings += E.ColumnsSetting.Internet + spliter;
            }

            if (commonGridSetting.title.visible) {
                columnSettings += E.ColumnsSetting.Title + spliter;
            }

            if (commonGridSetting.documentType.visible) {
                columnSettings += E.ColumnsSetting.Template + spliter;
            }

            if (commonGridSetting.location.visible) {
                columnSettings += E.ColumnsSetting.Location + spliter;
            }

            if (commonGridSetting.version.visible) {
                columnSettings += E.ColumnsSetting.Version + spliter;
            }

            if (commonGridSetting.approvedDate.visible) {
                columnSettings += E.ColumnsSetting.ApprovedDate + spliter;
            }

            if (commonGridSetting.approver.visible) {
                columnSettings += E.ColumnsSetting.Approver + spliter;
            }

            if (commonGridSetting.responsible.visible) {
                columnSettings += E.ColumnsSetting.Owner + spliter;
            }

            if (commonGridSetting.chapter.visible) {
                columnSettings += E.ColumnsSetting.Chapter + spliter;
            }

            if (commonGridSetting.documentId.visible) {
                columnSettings += E.ColumnsSetting.DocumentId + spliter;
            }

            if (commonGridSetting.hasAttachment.visible) {
                columnSettings += E.ColumnsSetting.Attachment + spliter;
            }

            if (commonGridSetting.readingReceipt.visible) {
                columnSettings += E.ColumnsSetting.ReadingReceipt + spliter;
            }

            if (commonGridSetting.readingReceiptDtmConfirmed.visible) {
                columnSettings += E.ColumnsSetting.ReadingReceiptDate + spliter;
            }

            //Remove last commna if any
            var lastSplitterIndex = columnSettings.lastIndexOf(spliter);
            if (lastSplitterIndex >= columnSettings.length - 1) {
                columnSettings = columnSettings.substring(0, lastSplitterIndex);
            }

            return columnSettings;
        };

        $scope.$on(broadcastType.printItemTarget, function (e, target) {
            if (target.itemType == 1) {
                $scope.printFolderPdf(3);
            } else {
                $scope.printDocumentPdf();
            }
        });

        $scope.printPicoFormPdf = function () {
            window.open(String.format(handbookRequests.PrintPicoFormPdfRequest, $scope.id, false), '_blank');
        }

        $scope.printAgreeMethodReport = function () {
            if ($scope.knowledgeTypeId == KnowledgeType.shortVersionOfAgreeRequirements) {
                window.open(String.format(handbookRequests.PrintAgreeMethodReportShortVersionRequest, $scope.id, false), '_blank');
                return;
            }
            window.open(String.format(handbookRequests.PrintAgreeMethodReportFullVersionRequest, $scope.id, false), '_blank');
        }
    }

})();